/**
 * PointCluster annotation geometry properties — registration and getters.
 *
 * Properties registered here:
 * - pointcluster_segments (JSON, PROJECT_GLOBAL) — Array<{pointcloudId: string, segmentId: number}>
 */

import { PropertyType, PropertyValueType } from '../../types';
import { propertyRegistry } from '../../PropertyRegistry';
import { getGlobalPropertyService } from '../../reactive/globalPropertyService';
import { TypedJsonProperty } from '../../reactive/TypedJsonProperty';

export type ClusterSegment = { pointcloudId: string; segmentId: number };

export function registerPointClusterGeometryProperties() {
  if (!propertyRegistry.isRegistered('pointcluster_segments')) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_GLOBAL,
      identifier: 'pointcluster_segments',
      name: 'Segments',
      valueType: PropertyValueType.JSON,
      defaultValue: '[]',
      annotationTypes: [],
    });
  }
}

registerPointClusterGeometryProperties();

const segmentsCache = new Map<string, TypedJsonProperty<ClusterSegment[]>>();

export function getPointClusterSegmentsProperty(annotationId: string): TypedJsonProperty<ClusterSegment[]> {
  const cached = segmentsCache.get(annotationId);
  if (cached && !cached.isDestroyed) return cached;

  const service = getGlobalPropertyService();
  const raw = service.getProperty('pointcluster_segments', annotationId, PropertyType.PROJECT_GLOBAL);
  const typed = new TypedJsonProperty<ClusterSegment[]>(raw);
  segmentsCache.set(annotationId, typed);
  return typed;
}
